import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Response } from '../../common/Response';

@Injectable({
  providedIn: 'root'
})
export class EmopPublicUsercenterSelectorService {

  /**
   * 加载子级
   * @param deptParentId 父级id
   */
  lazyChildren(deptParentId: string, keyword: string = '') {
    return this.http.get<Response<any>>('/usercenter/lazy-dept-user-tree', {
      params: {
        deptParentId,
        keyword
      }
    });
  }
  constructor(
    private http: HttpClient
  ) { }
}
